import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
  Button,
  TextField,
  Switch, FormControlLabel, Divider, Grid, FormControl, InputLabel, MenuItem, Select, IconButton, InputAdornment
} from '@mui/material';
import {
  AdminPanelSettings,
  People,
  PersonAdd,
  VerifiedUser,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material';
import AdminRoles from './AdminRoles';
import AdminUsers from './AdminUsers';
import CommonModal from '../components/common/CommonModal';
import { createRole, getAdminRoles, createAdminUsers,createSuperAdmin } from '../services/adminUserService'
import { useNotification } from '../contexts/NotificationContext'
import outletService from '../services/outletService';
// import RoleModal from '../components/common/RoleModal';
// import UserModal from '../components/common/UserModal';



function UserSettingsManagement() {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [modalOpen, setModalOpen] = useState(false)
  const [userModalOpen, setUserModalOpen] = useState(false)
  const [superAdminModal, setSuperAdminModal] = useState(false)

  const [refreshRoles, setRefreshRoles] = useState(false);
  const [refreshUsers, setRefreshUsers] = useState(false);

  const handleRoleCreated = () => {
    setRefreshRoles(prev => !prev); // Toggle boolean to trigger refresh
    setModalOpen(false);
  };

  const handleUserCreated = () => {
    setRefreshUsers(prev => !prev); // Toggle boolean to trigger refresh
    setUserModalOpen(false);
  };


  const handleTabsChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {

  }, [modalOpen])

  return (
    <Box sx={{ flexGrow: 1, height: '100vh', p: isMobile ? 1 : 3, pt: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>

        <Typography variant={isMobile ? 'h5' : 'h4'} gutterBottom>
          User Settings Management
        </Typography>
        <Box>
          {!JSON.parse(localStorage.getItem('admin_outlet_id')) && 
          <>
          <Button variant='contained' sx={{ mr: 1 }}
            onClick={() => setSuperAdminModal(true)}
            startIcon={<VerifiedUser />}
          >Create Super Admin</Button> 
          <Button variant='contained' sx={{ mr: 1 }}
            onClick={() => setModalOpen(true)}
            startIcon={<VerifiedUser />}
          >Create Role</Button> 
          </>}
          <Button variant='contained'
            onClick={() => setUserModalOpen(true)}
            startIcon={<PersonAdd />}
          >Create User</Button>
        </Box>
      </Box>

      <Paper sx={{ mb: 3, borderRadius: 0 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabsChange}
          sx={{ borderRadius: 0 }}
          variant={isMobile ? 'scrollable' : 'fullWidth'}
        >
          <Tab
            label="Admin Roles"
            icon={<AdminPanelSettings />}
            iconPosition="start"
          />
          <Tab
            label="Admin Users"
            icon={<People />}
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      {activeTab === 0 && (
        <AdminRoles refresh={refreshRoles} />
      )}

      {activeTab === 1 && (
        <AdminUsers refresh={refreshUsers} />
      )}

      <CommonModal modalOpen={modalOpen} setModalOpen={setModalOpen} children={<RoleModal setModalOpen={handleRoleCreated} />} modalWidth={600} />

      <CommonModal modalOpen={userModalOpen} setModalOpen={setUserModalOpen} children={<UserModal setModalOpen={handleUserCreated} />} modalWidth={600} />

      <CommonModal modalOpen={superAdminModal} setModalOpen={setSuperAdminModal} children={<SuperAdminModal setSuperAdminModal={setSuperAdminModal} />} modalWidth={600} />
    </Box>
  );
}


const RoleModal = ({ setModalOpen }) => {
  const [tabs, setTabs] = useState([
   
    { "name": "Delivery", "value": "delivery" },
    { "name": "Reservations", "value": "reservations" },
    { "name": "Table Orders", "value": "table_orders" },
    { "name": "Catering Info", "value": "catering_info" },
    { "name": "Catering Config", "value": "catering_config" },
    { "name": "Notification", "value": "notifications" },
    { "name": "Reports", "value": "reports" },
    { "name": "Outlets", "value": "outlets" },
    { "name": "Configuration", "value": "configuration" },
    { "name": "Social Links", "value": "social_links" },
    { "name": "User Settings", "value": "user_settings" },
    { "name": "Users", "value": "users" },
    { "name": "Token Management", "value": "token_management" },
    { "name": "Printers", "value": "printers" },
    { "name": "Testimonials", "value": "testimonials" },
    { "name": "Feedback", "value": "feedback" },
    { "name": "Menu", "value": "menu" },
    // { "name": "Analytics", "value": "analytics" },
  
  ]);

  const [switchValues, setSwitchValues] = useState(
    {
      "configuration": false,
      "social_links": false,
      "outlets": false,
      "menu": false,
      "delivery": false,
      "catering_config": false,
      "catering_info": false,
      "reports": false,
      "notifications": false,
      "reservations": false,
      "table_orders": false,
      "token_management": false,
      "testimonials": false,
      "users": false,
      "user_settings": false,
      "analytics": false
    }
  );
  const [roleName, setRoleName] = useState('');
  const { showSuccess, showError } = useNotification()

  const handleChange = (value, checked) => {
    setSwitchValues(prev => ({
      ...prev,
      [value]: checked
    }));
  };

  const handleRoleNameChange = (e) => {
    setRoleName(e.target.value);
  };

  const handleSelectAll = () => {
    const allSelected = {};
    tabs.forEach(tab => {
      allSelected[tab.value] = true;
    });
    setSwitchValues(allSelected);
  };

  const handleClearAll = () => {
    setSwitchValues({
      "configuration": false,
      "social_links": false,
      "outlets": false,
      "menu": false,
      "delivery": false,
      "catering_config": false,
      "catering_info": false,
      "reports": false,
      "notifications": false,
      "reservations": false,
      "table_orders": false,
      "token_management": false,
      "testimonials": false,
      "users": false,
      "user_settings": false,
      "analytics": false
    });
  };

  const handleCreateRole = async () => {

    if (!roleName) {
      showError("Please Enter Role Name")
      return;
    }

    if (roleName === "") {
      showError("Please Enter Role Name")
      return;
    }

    // console.log("Switch Values => ", switchValues)
    let payload = {
      "role": roleName,
      "tabs_permitted": switchValues
    }

    try {
      const response = await createRole(payload)
      showSuccess(response?.data?.message)
      setModalOpen()
    }
    catch (error) {
      console.error(error)
    }

  }

  return (
    <>
      <Typography variant='h5' sx={{ textAlign: 'center', mb: 3, fontWeight: 'bold' }}>
        Create Role
      </Typography>

      <TextField
        fullWidth
        label="Role Name"
        value={roleName}
        onChange={handleRoleNameChange}
        sx={{ mb: 3 }}
        variant="outlined"
        placeholder="Enter role name"
      />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={handleSelectAll}
        >
          Select All
        </Button>
        <Button
          variant="outlined"
          size="small"
          color="error"
          onClick={handleClearAll}
        >
          Clear All
        </Button>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        {tabs.map((tab, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <FormControlLabel
              control={
                <Switch
                  checked={switchValues[tab.value] || false}
                  onChange={(e) => handleChange(tab.value, e.target.checked)}
                  color="primary"
                  size="medium"
                />
              }
              label={tab.name}
              sx={{
                width: '100%',
                m: 0,
                p: 1,
                borderRadius: 1,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            />
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <Button variant="outlined" color="inherit" onClick={() => setModalOpen(false)}>
          Cancel
        </Button>
        <Button variant="contained" color="primary"
          onClick={handleCreateRole}
        >
          Create Role
        </Button>
      </Box>
    </>
  );
};


const UserModal = ({ setModalOpen }) => {

  const [formData, setFormData] = useState({
    "username": "",
    "password": "",
    "full_name": "",
    "email": "",
    "phone": "",
    "role_id": "",
    "outlet_id": ""
  })

  const [fields, setFields] = useState([
    { "name": "Username", "value": "username", "required": true, "type": "text" },
    { "name": "Password", "value": "password", "required": true, "type": "password" },
    { "name": "Full Name", "value": "full_name", "required": false, "type": "text" }
  ])

  const [adminRoles, setAdminRoles] = useState([])
  const [showPassword, setShowPassword] = useState(false);
  const [role, setRole] = useState(0)
  const [outlets, setOutlets] = useState([])
  const { showSuccess, showError } = useNotification()


  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  async function fetchAdminRoles() {
    try {
      const response = await getAdminRoles()
      setAdminRoles(response.data)
      // console.log("Admin Roles => ", response)
    }
    catch (error) {
      console.error(error)
    }
  }

  async function fetchOutlets() {
    try {
      const outletResponse = await outletService.getOutlets()
      setOutlets(outletResponse)
    }
    catch (error) {
      showError("Error While Retrieving Outlets")
    }
  }

  useEffect(() => {
    fetchAdminRoles()
    fetchOutlets()
  }, [])


  const handleInputChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRoleSelect = (value) => {
    setRole(value)
    setFormData(prev => ({
      ...prev,
      ["role_id"]: value
    }));
  }


  const handleOutletSelect = (value) => {
    setFormData(prev => ({
      ...prev,
      ["outlet_id"]: value
    }));
  }

  const handleSubmit = async () => {
    // console.log("Form Data => ", formData)

    if (!formData.username) {
      showError("Please Enter Username")
      return;
    }

    if (formData.username === "") {
      showError("Please Enter Username")
      return;
    }

    if (formData.username !== "" && formData.username.length > 20) {
      showError("Please Enter Username Below 20 Characters")
      return;
    }


    if (formData.password.length < 8) {
      showError("Please Enter Password atleast 8 Characters")
      return;
    }

    if (formData.role_id === "") {
      showError("Please Select Role")
      return;
    }

    if (!formData.outlet_id) {
      showError("Please Select Outlet")
      return;
    }

    if (formData.outlet_id === "") {
      showError("Please Select Outlet")
      return;
    }




    try {
      const response = await createAdminUsers(formData);
      showSuccess(response.message)
      setModalOpen()
      setFormData({
        "username": "",
        "password": "",
        "full_name": "",
        "email": "",
        "phone": "",
        "role_id": ""
      })
      setAdminRoles(0)
    }
    catch (error) {
      console.error(error)
      showError(error.message)
    }

  }
  return (
    <>
      <Typography variant='h5' sx={{ textAlign: 'center', mb: 2 }}>Create Admin User</Typography>

      <Box>
        <FormControl fullWidth sx={{ mt: 1, mb: 1 }}>
          <InputLabel id="demo-simple-select-label">Select Role</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={role}
            label="Select Role"
            onChange={(e) => handleRoleSelect(e.target.value)}
          >
            <MenuItem value={0}>Select Role</MenuItem>
            {adminRoles.map((role, index) => {
              return (
                <MenuItem value={role.id}>{role.role}</MenuItem>
              )
            })}
          </Select>
        </FormControl>



        <FormControl fullWidth sx={{ mt: 1, mb: 1 }}>
          <InputLabel id="demo-simple-select-label">Select Outlet</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={formData.outlet_id}
            label="Select Outlet"
            onChange={(e) => handleOutletSelect(e.target.value)}
          >
            <MenuItem value={0}>Select Outlet</MenuItem>
            {outlets.map((outlet, index) => {
              return (
                <MenuItem value={outlet.id}>{outlet.name}</MenuItem>
              )
            })}
          </Select>
        </FormControl>


        {fields.map((field, index) => {
          // Determine if this field is a password field
          const isPasswordField = field.type === 'password';

          return (
            <TextField
              key={index}
              sx={{ mb: 2, mt: 1 }}
              fullWidth
              type={isPasswordField && showPassword ? 'text' : field.type}
              label={field.name}
              required={field.required}
              onChange={(e) => handleInputChange(field.value, e.target.value)}
              InputProps={
                isPasswordField ? {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleTogglePassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                } : {}
              }
            />
          );
        })}

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant='contained' sx={{ mr: 1 }} onClick={handleSubmit}>Create</Button>
          <Button variant='outlined' onClick={() => setModalOpen(false)}>Cancel</Button>
        </Box>


      </Box>

    </>
  )
}


const SuperAdminModal = ({ setSuperAdminModal }) => {

   const [formData, setFormData] = useState({
    "username": "",
    "password": "",
    "full_name": "",
  })

  const [fields, setFields] = useState([
    { "name": "Username", "value": "username", "required": true, "type": "text" },
    { "name": "Password", "value": "password", "required": true, "type": "password" },
    { "name": "Full Name", "value": "full_name", "required": false, "type": "text" }
  ])

  const [showPassword, setShowPassword] = useState(false);

  const { showSuccess, showError } = useNotification()



  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

    const handleInputChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    // console.log("Form Data => ", formData)

    if (!formData.username) {
      showError("Please Enter Username")
      return;
    }

    if (formData.username === "") {
      showError("Please Enter Username")
      return;
    }

    if (formData.username !== "" && formData.username.length > 20) {
      showError("Please Enter Username Below 20 Characters")
      return;
    }


    if (formData.password.length < 8) {
      showError("Please Enter Password atleast 8 Characters")
      return;
    }




    try {
      const response = await createSuperAdmin(formData);
      showSuccess(response.message)
      setSuperAdminModal(false)
      setFormData({
        "username": "",
        "password": "",
        "full_name": "",
      })
    }
    catch (error) {
      console.error(error)
      showError(error.message)
    }

  }


  return (
    <>
      <Box>
        <Typography variant='h5' sx={{ textAlign: 'center', mb: 2 }}>Create Super Admin</Typography>
        {fields.map((field, index) => {
          // Determine if this field is a password field
          const isPasswordField = field.type === 'password';

          return (
            <TextField
              key={index}
              sx={{ mb: 2, mt: 1 }}
              fullWidth
              type={isPasswordField && showPassword ? 'text' : field.type}
              label={field.name}
              required={field.required}
              onChange={(e) => handleInputChange(field.value, e.target.value)}
              InputProps={
                isPasswordField ? {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleTogglePassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                } : {}
              }
            />
          );
        })}

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant='contained' sx={{ mr: 1 }} onClick={handleSubmit}>Create</Button>
          <Button variant='outlined' onClick={() => setSuperAdminModal(false)}>Cancel</Button>
        </Box>
      </Box>

    </>
  )
}





export default UserSettingsManagement;